import { render, staticRenderFns } from "./merchantReview.vue?vue&type=template&id=50177ac9"
import script from "./merchantReview.vue?vue&type=script&lang=js"
export * from "./merchantReview.vue?vue&type=script&lang=js"
import style0 from "./merchantReview.vue?vue&type=style&index=0&id=50177ac9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports